<template>
  <div class="download-pdf">
    <div class="download-pdf__inner">
      <table class="download-pdf__header-table">
        <tr>
          <td>
            <img class="download-pdf__header-table-logo" src="/static/images/logo.png" alt="" />
          </td>
          <td class="download-pdf__header-table-info">
            <p style="margin: 5px 0">{{ marketplace.schedule }}</p>
            <a :href="`tel:${phone}`" target="_blank" style="margin: 5px 0">{{ phone }}</a>
            <a href="https://babymarket05.ru" target="_blank" style="margin-top: 20px">{{ domain }}</a>
          </td>
        </tr>
      </table>

      <table style="width: 100%; margin-bottom: 15px">
        <tr>
          <td style="font-size: 18px; color: #e1e1e1; font-weight: bold">
            {{ pageTitle }} от {{ currentDate }} <span style="margin-left: 5px">{{ currentTime }}</span>
          </td>
        </tr>
      </table>

      <table class="products-table" style="border-collapse: collapse; width: 100%">
        <thead>
          <tr>
            <th style="padding: 12px 8px; text-align: left; font-weight: bold">Фото</th>
            <th style="padding: 12px 8px; text-align: left; font-weight: bold">Название</th>
            <th style="padding: 12px 8px; text-align: center; font-weight: bold">Количество</th>
            <th style="padding: 12px 8px; text-align: right; font-weight: bold; width: 150px">
              {{ isWishlist ? "Цена" : "Сумма" }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in items"
            :key="isWishlist ? item.id : item.item.id"
            style="border-bottom: 1px solid #e1e1e1"
          >
            <td style="width: 70px; padding: 12px 8px; vertical-align: middle">
              <ImgComponent
                v-if="getItemImage(item)"
                :head_img="getItemImage(item)"
                width="100"
                height="100"
                style="width: 50px; height: 50px"
                :loader="false"
                contain
              />
              <div v-else style="text-align: center; color: #999; font-style: italic; font-size: 11px">
                Нет фото
              </div>
            </td>
            <td
              style="
                padding: 12px 8px;
                vertical-align: middle;
                font-weight: normal;
                color: #859a90;
                text-decoration: underline;
              "
            >
              {{ getItemTitle(item) }}
            </td>
            <td style="padding: 12px 8px; vertical-align: middle; text-align: center; color: #859a90">
              {{ getItemCount(item) }}
            </td>
            <td
              style="
                padding: 12px 8px;
                vertical-align: middle;
                text-align: right;
                color: #859a90;
                width: 150px;
              "
            >
              {{ getItemPrice(item) | formatPrice }}
            </td>
          </tr>
        </tbody>
      </table>

      <table style="width: 100%; margin-top: 20px">
        <tr>
          <td style="font-size: 24px; font-weight: bold; color: #969798">Общая стоимость товаров:</td>
          <td style="text-align: right; font-size: 24px; font-weight: bold; color: #969798">
            {{ sum | formatPrice }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "DownloadPdfPage",
  data() {
    return {
      items: [],
      sum: 0,
      discount: 0,
      isWishlist: false,
    };
  },
  computed: {
    pageTitle() {
      return this.isWishlist ? "Список желаний" : "Корзина";
    },
    currentDate() {
      return (
        new Date().toLocaleDateString("ru-RU", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }) + "г "
      );
    },
    currentTime() {
      return new Date().toLocaleTimeString("ru-RU", {
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    marketplace() {
      return this.$store.state.marketplace || {};
    },
    phone() {
      if (this.marketplace?.communications && this.marketplace.communications.length) {
        return this.marketplace.communications.find(
          (item) => item.type.code === this.$store.state._types.PHONE
        )?.value;
      }
      return "79896680101";
    },
    email() {
      if (this.marketplace?.communications && this.marketplace.communications.length) {
        return this.marketplace.communications.find(
          (item) => item.type.code === this.$store.state._types.EMAIL
        )?.value;
      }
      return null;
    },
    domain() {
      const url = this.$store.state._env.APOLLO_ENDPOINT;
      try {
        const parsedUrl = new URL(url);
        return parsedUrl.hostname;
      } catch (error) {
        console.error("Invalid URL:", error);
        return null;
      }
    },
  },
  async mounted() {
    // Определяем тип страницы из query параметра
    this.isWishlist = this.$route.query.type === "wishlist";

    await this.loadData();

    // Автоматически открываем диалог печати при загрузке страницы
    this.$nextTick(() => {
      setTimeout(() => {
        window.print();
        // Закрываем окно после печати
        setTimeout(() => {
          window.close();
        }, 500);
      }, 1000);
    });
  },
  methods: {
    async loadData() {
      if (this.isWishlist) {
        await this.loadWishlistData();
      } else {
        await this.loadCartData();
      }
    },
    async loadCartData() {
      try {
        // Загружаем данные корзины через store action
        await this.$store.dispatch("GET_CART_ITEMS", {
          apollo: this.$apollo.provider.defaultClient,
        });

        // Получаем данные корзины из store
        this.items = this.$store.state.auth.cart.filter((i) => i.item);

        // Вычисляем сумму
        this.sum = this.items
          .map((r) => this.$options.filters.share_price(r.item?.price, r.item) * r.count)
          .reduce((a, b) => a + b, 0);

        // Вычисляем скидку
        this.discount =
          this.items.map((r) => parseFloat(r.item?.price) * r.count).reduce((a, b) => a + b, 0) - this.sum;
      } catch (error) {
        console.error("Ошибка при загрузке данных корзины:", error);
        // В случае ошибки пытаемся получить данные из store
        this.items = this.$store.state.auth.cart?.filter((i) => i.item) || [];
        this.sum = this.items
          .map((r) => this.$options.filters.share_price(r.item?.price, r.item) * r.count)
          .reduce((a, b) => a + b, 0);
        this.discount =
          this.items.map((r) => parseFloat(r.item?.price) * r.count).reduce((a, b) => a + b, 0) - this.sum;
      }
    },
    async loadWishlistData() {
      try {
        // Загружаем данные избранного через store action
        await this.$store.dispatch("GET_ALL_FAVORITES", {
          apollo: this.$apollo.provider.defaultClient,
        });

        // Получаем данные избранного из store
        this.items = this.$store.state.auth.favorites_objects;

        // Вычисляем сумму
        this.sum = this.items
          .map((item) => this.$options.filters.share_price(item.price, item))
          .reduce((a, b) => a + b, 0);
      } catch (error) {
        console.error("Ошибка при загрузке данных списка желаний:", error);
        // В случае ошибки пытаемся получить данные из store
        this.items = this.$store.state.auth.favorites?.filter((item) => item.id) || [];
        this.sum = this.items
          .map((item) => this.$options.filters.share_price(item.price, item))
          .reduce((a, b) => a + b, 0);
      }
    },
    getItemImage(item) {
      if (this.isWishlist) {
        // Для wishlist - item это сам товар
        return item.head_img && item.head_img.path ? this.$options.filters.item_img(item) : null;
      } else {
        // Для корзины - item.item это товар
        return item.item.head_img && item.item.head_img.path
          ? this.$options.filters.item_img(item.item)
          : null;
      }
    },
    getItemTitle(item) {
      return this.isWishlist ? item.title : item.item.title;
    },
    getItemCount(item) {
      return this.isWishlist ? 1 : item.count;
    },
    getItemPrice(item) {
      if (this.isWishlist) {
        return this.$options.filters.share_price(item.price, item);
      } else {
        return this.$options.filters.share_price(item.item.price, item.item) * item.count;
      }
    },
  },
  metaInfo() {
    return {
      title: this.pageTitle,
    };
  },
};
</script>

<style lang="stylus">
.download-pdf {
	padding: 100px 20px;
	color: #333;

	&__inner {
		max-width: 60rem
		margin 0 auto;
	}

	&__header-table {
		width: 100%;
		margin-bottom: 15px;
		border-bottom: 1px solid #e1e1e1;
		padding-bottom: 20px

		&-logo {
			height: 90px
			width auto
		}

		&-info {
			display flex
			flex-direction column
			align-items flex-end
			font-weight: 600;
			font-size: 1.125rem
			line-height: 145%;
			letter-spacing: 0%;
			text-align: right;

			p, a {
				color: #e1e1e1
			}
		}
	}
}

/* Стили для табличной вёрстки */
table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 30px;
}

th, td {
  padding: 12px 8px;
  text-align: left;
  vertical-align: middle;
}

th {
  font-weight: bold;
  color: #333;
  font-size: 13px;
}

@media screen and (max-width: 768px) {
  table {
    th, td {
      padding: 8px 4px;
      font-size: 10px;
    }
  }
}
</style>
